module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Sheila-Tendero-75275c6a3350fe9612a5c77459b3997f.png";